'use client'

import { useState, useCallback, useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'

import {
  selfServiceViewScreenEvent,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import TrackingJourneySummaryModal from '../TrackingJourneySummaryModal'

const TrackShipmentLink = () => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const shipmentId = conversation?.transaction?.shipment?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const trackModalScreen = useCallback(() => {
    if (!transactionId) return

    track(
      selfServiceViewScreenEvent({
        screen: 'track_shipment_view',
        transactionId,
        variant: 'modal',
      }),
    )
  }, [track, transactionId])

  const trackTrackingLinkClick = useCallback(() => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'tracking_information_link',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }, [track, transactionId])

  const handleModalOpen = useCallback(() => {
    trackTrackingLinkClick()
    trackModalScreen()

    setIsModalOpen(true)
  }, [trackTrackingLinkClick, trackModalScreen, setIsModalOpen])

  const closeModal = () => setIsModalOpen(false)

  useEffect(() => {
    const handleShipmentLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.ShipmentTrackingLink)) return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handleShipmentLinkClick)

    return () => {
      document.body.removeEventListener('click', handleShipmentLinkClick)
    }
  }, [handleModalOpen])

  if (!transactionId) return null

  return (
    <TrackingJourneySummaryModal
      isOpen={isModalOpen}
      transactionId={transactionId}
      shipmentId={shipmentId}
      onClose={closeModal}
    />
  )
}

export default TrackShipmentLink
